export default "__VITE_ASSET__D306u5rL__"